import { CommonModule, Location } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, type OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LocaleSharedModule } from '@app/i18n/locale-shared.module';
import { LibraryRouter } from '@app/models/library.router';
import { getLibraryRouteData } from '@app/store/reducers/library.reducer';
import { Store } from '@ngrx/store';
import { filter, takeUntil } from 'rxjs/operators';
import { AbstractPane } from '../models/abstract-pane';

@Component({
  selector: 'app-goback-pane',
  templateUrl: './goback-pane.component.html',
  styleUrls: ['./goback-pane.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [LocaleSharedModule, CommonModule, RouterModule],
})
export class GobackPaneComponent extends AbstractPane implements OnInit {
  protected location = inject(Location);
  protected readonly store = inject(Store);

  public path: string;
  public queryParams: any;

  protected libRouter = new LibraryRouter();

  public ngOnInit(): void {
    this.store
      .select(getLibraryRouteData)
      .pipe(
        filter((v) => !!v),
        takeUntil(this.destroyed$),
      )
      .subscribe({
        next: (routeData) => {
          this.libRouter.setLibraryFilterData(routeData);
          const url = this.libRouter.getUpLink();
          this.path = url.path;
          this.queryParams = url.parameters;

          this.markForCheck();
        },
        error: (error) => {
          this.errorNotificationService.captureError(error, 'LOAD-SOMEDATA');
        },
      });
  }

  hasContent(): boolean {
    return true;
  }

  protected onContentLoaded(viaQuery?: boolean): void {
    this.isVisible = true;
  }
}
